import { tv, type VariantProps } from 'tailwind-variants'
import { Slot } from '@radix-ui/react-slot'

const styles = tv(
	{
		base: 'rounded-lg border border-primary-light mb-10',
		variants: {
			size: {
				sm: 'py-4 px-3',
				lg: 'py-8 px-10',
			},
		},
	},
	{
		responsiveVariants: ['sm', 'lg'],
	},
)

export interface InfoContainerProps extends VariantProps<typeof styles>, React.ButtonHTMLAttributes<HTMLDivElement> {
	className?: string
	children: React.ReactNode
	asChild?: boolean
}

export const InfoContainer = ({ className, children, asChild, ...rest }: InfoContainerProps) => {
	const Comp = asChild ? Slot : 'div'

	return (
		<Comp className={styles({ class: className, size: { initial: 'sm', lg: 'lg' } })} {...rest}>
			{children}
		</Comp>
	)
}
